module.exports = __webpack_public_path__ + "img/selected1-min.4e97125f.png";